import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackAddOfferToComparison, trackDeleteOfferFromComparison } from './tracking';
import { addOfferToComparison, deleteOfferFromComparison } from '../../actions/offersComparison';
import { ComparisonButton } from '../../components/ComparisonButton';
import { ComparisonButtonActive } from '../../components/ComparisonButtonActive';
import { ComparisonTooltip } from '../../components/ComparisonTooltip';
import { useFavoritesUxfeedbackCampaign } from '../../hooks/uxfeedback';
import {
  EStatus,
  IComparisonStatusInfoSchema,
} from '../../repositories/favorites/entities/comparison_status_info/ComparisonStatusInfoSchema';

export interface IComparisonButtonContainerProps {
  comparisonStatus: IComparisonStatusInfoSchema;
  entityId: number;
  label: string;
}

export const ComparisonButtonContainer: React.FC<IComparisonButtonContainerProps> = ({
  comparisonStatus,
  entityId,
  label,
}) => {
  const dispatch = useDispatch();
  const { sendFavoritesUxfeedbackCampaign } = useFavoritesUxfeedbackCampaign();

  const { description, isAdded, isUnavailable } = React.useMemo(
    () => ({
      description: comparisonStatus.description || null,
      isAdded: comparisonStatus.status === EStatus.Added,
      isUnavailable: comparisonStatus.status === EStatus.Unavailable,
    }),
    [comparisonStatus],
  );

  const handleAddClick = React.useCallback(() => {
    dispatch(addOfferToComparison({ entityId }));
    trackAddOfferToComparison({ offerId: entityId, label });
    sendFavoritesUxfeedbackCampaign();
  }, [dispatch, entityId, label, sendFavoritesUxfeedbackCampaign]);

  const handleRemoveClick = React.useCallback(() => {
    dispatch(deleteOfferFromComparison({ entityId }));
    trackDeleteOfferFromComparison({ offerId: entityId, label });
  }, [dispatch, entityId, label]);

  const button = isAdded ? (
    <ComparisonButtonActive onClick={handleRemoveClick} />
  ) : (
    <ComparisonButton onClick={handleAddClick} disabled={isUnavailable} />
  );

  if (!description) {
    return button;
  }

  return <ComparisonTooltip content={description}>{button}</ComparisonTooltip>;
};
